'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.js');
var events = require('./events.js');

var _excluded = ["target"];
/**
 * Attaches a set of valid event callbacks to a Google maps element using the
 * naming convention of React's SyntheticEvents.
 *
 * @param {object} config
 * @param {any} config.target A Google Maps element (e.g. Marker, Map, etc)
 * @param {...function} config.listeners Key-value pairs of callbacks named
 *   with valid React-style event names. The will be converted to native DOM
 *   names.
 */

function attachEventListeners(_ref) {
  var {
    target
  } = _ref,
      listeners = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  Object.entries(listeners).forEach(_ref2 => {
    var [handle, callback] = _ref2;
    var nativeHandle = events.EVENT_MAP[handle];

    if (!nativeHandle) {
      console.warn("Event handler ".concat(handle, " is not a valid Google Maps event"));
      return;
    } // Only attach the listener if a callback was included in the target props.


    if (callback) {
      target.addListener(nativeHandle, callback);
    }
  });
}

exports.attachEventListeners = attachEventListeners;
